import React, { useEffect } from 'react'; //useState
import { Typography, CircularProgress } from '@mui/material';
import RouteConstants from '../../constants/routeConstants';
// import history from '../../sharedcomponents/emptyStateContainer/history';
// import { useHistory } from 'react-router-dom';
import { unregister } from '../../registerServiceWorker';

import './unauthenticatedUI.css';

const UnauthenticatedUI = () => {
    // const history = useHistory();

    useEffect(() => {
        // history.replace(RouteConstants.SESSION_TIMEOUT, {});

        //... Unregister the service worker.
        unregister();

        let date = new Date();
        let ts = date.getTime();

        //... Append a time stamp so that the browsers don't cache the url.
        const publicUrl = new URL(process.env.PUBLIC_URL, window.location.origin);
        let url = `${publicUrl}?ts=${ts}`;


        //... Wait for sometime to get the service worker unregistered before redirecting to the root url.
        setTimeout(() => {
            localStorage.clear();
            //... Redirect to home so that user gets the ADFS sign-in page.
            window.location.href = url;
        }, 1000);
    }, []);

    return (
        <div className="unauthenticated-ui-container">
            <CircularProgress color="secondary" />
            <br />
            <Typography>Please wait...</Typography>
        </div>
    );
};

export default {
    routeProps: {
        path: RouteConstants.SESSION_TIMEOUT,
        component: UnauthenticatedUI,
    },
    name: 'UnauthenticatedUI',
};